module.exports = __webpack_public_path__ + "img/avatar.55d862a2.gif";